import * as css from './AccountHeader.css';
import {useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {List} from '@tickchak/react-share/app';
import useAccountMenu from '../../../../../tickchakHooks/useAccontMenu';
import useShow from '../../../../../hooks/useShow';
import AccountMenuIcon from '../AccountMenuIcon/AccountMenuIcon';
import AccountVerifyChip from '../AccountVerifyChip/AccountVerifyChip';
import AccountSwitcher from '../AccountSwitcher/AccountSwitcher';

const DASHBOARD_ITEMS = ['crmAccount', 'packageSettings', 'reports', 'whatsapp', 'mailing', 'crowd', 'accountsCash', 'teamAccount'];

function AccountHeader() {
    const account = useSelector((s: any) => s.account);
    const isVerified = !!account.bankVerified;
    const {t} = useTranslation('package');
    const {t: layoutT} = useTranslation('layout');
    const accountMenu = useAccountMenu();
    const items = accountMenu().arr;
    const subList = useShow();
    const cardRef = useRef<HTMLDivElement>(null);
    const [openItem, setOpenItem] = useState<any>(null);
    const [position, setPosition] = useState<any>({width: '250px', minHeight: 'auto'});

    const openSubList = (item, e) => {
        const card = cardRef.current;
        if(card && e?.currentTarget) {
            const icon = e.currentTarget.getBoundingClientRect();
            const rect = card.getBoundingClientRect();
            setPosition({
                width: '250px',
                minHeight: 'auto',
                top: Math.round(icon.bottom - rect.top + 8),
                inlineStart: Math.round(rect.right - icon.right) + 'px',
            });
        }
        setOpenItem(item);
        subList.open();
    };

    const handleClick = (item, e) => {
        if(item.list)
            return openSubList(item, e);
        (item.onClick || item.onClickMenu)?.(item);
    };

    const subItems = openItem?.list?.arr?.map((sub, i) => ({id: i, text: layoutT(sub.title || sub.text)})) || [];

    return (
        <css.card data-cy="account-header" ref={cardRef}>
            <css.menu>
                {DASHBOARD_ITEMS.map((key) => {
                    const item = items.find((i) => i.key === key);
                    return item && (
                        <AccountMenuIcon key={key} icon={item.icon} text={t(`layout:${key}`)}
                            dataCy={key} hasArrow={!!item.list} onClick={(e) => handleClick(item, e)}/>
                    );
                })}
            </css.menu>
            <css.nameBlock>
                <css.labelRow>
                    <css.nameLabel>{t('accountName')}</css.nameLabel>
                    {isVerified && <AccountVerifyChip isVerified/>}
                </css.labelRow>
                <css.nameRow>
                    <css.nameText>{account.title}</css.nameText>
                    <AccountSwitcher cardRef={cardRef}/>
                </css.nameRow>
                <css.accountNumber>{t('accountNumber')} {account.pid}</css.accountNumber>
            </css.nameBlock>
            {!isVerified && <AccountVerifyChip/>}
            {subList.isOpen && openItem?.list &&
                <List show={subList} position={position} data-cy="account-menu-sublist"
                    onItemClick={(sub) => {
                        openItem.list.onClick(openItem.list.arr[Number(sub.id)]);
                        subList.close();
                    }}>
                    <List.Header title={layoutT(openItem.list.title)}/>
                    <List.Items items={subItems}/>
                </List>}
        </css.card>
    );
}

export default AccountHeader;
